import { render, staticRenderFns } from "./AddRegister.vue?vue&type=template&id=56934a9e&"
import script from "./AddRegister.vue?vue&type=script&lang=js&"
export * from "./AddRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports